/* eslint-disable object-curly-newline */
import { useState } from 'preact/hooks';
import PropTypes from 'prop-types';

import Header from '@ui-kit/typography/header';
import SecondaryText from '@ui-kit/typography/secondaryText';
import Box from '@ui-kit/box';
import BreakLine from '@ui-kit/dividers/breakLine';
import Tabs from '@ui-kit/tabs/Tabs';

import AddedContractDataEdit from './sections/addedContractDataEdit/AddedContractDataEdit';
import AddedContractDataView from './sections/addedContractDataView/AddedContractDataView';
import AddedContractSummaryView from './sections/addedContractSummaryView/AddedContractSummaryView';

function ReviewAddedContract({ contractFile, contractData, handleSetContractData, loadContracts, closeFunction }) {
  const [currentTab, setCurrentTab] = useState('ai');

  const handleTabChange = (tab) => {
    setCurrentTab(tab.value);
  };

  return (
    <Box>
      <Header>Review and Save</Header>
      <SecondaryText mb="0.5rem" mt="0.75rem" fontSize="0.813rem">
        The following data was extracted from the agreement.
      </SecondaryText>

      <Box mt="1rem" mb="1.25rem">
        <Tabs
          tabs={[{ name: 'AI Summary', value: 'ai' }, { name: 'Standard Fields', value: 'fields' }, { name: 'Edit', value: 'edit' }]}
          handleTabChange={handleTabChange}
          selectedTab={currentTab}
        />
      </Box>

      <BreakLine mb="1.5em" color="var(--panel-info-border)" />

      {currentTab === 'ai' && (
        <AddedContractSummaryView
          contractSummary={contractData.summary}
          contractData={contractData}
          contractFile={contractFile}
          loadContracts={loadContracts}
          closeFunction={closeFunction}
        />
      )}

      {currentTab === 'fields' && (
        <AddedContractDataView
          contractData={contractData}
          contractFile={contractFile}
          loadContracts={loadContracts}
          closeFunction={closeFunction}
        />
      )}

      {currentTab === 'edit' && (
        <AddedContractDataEdit
          contractData={contractData}
          handleSetContractData={handleSetContractData}
          handleFinishEditing={() => setCurrentTab('ai')}
        />
      )}

    </Box>
  );
}

ReviewAddedContract.propTypes = {
  contractFile: PropTypes.object.isRequired,
  contractData: PropTypes.object.isRequired,
  handleSetContractData: PropTypes.func.isRequired,
  loadContracts: PropTypes.func.isRequired,
  closeFunction: PropTypes.func.isRequired,
};

export default ReviewAddedContract;
